import { createFileRoute } from '@tanstack/react-router';

/**
 * `/time` — TT-V11 Phase 1 (T00): a real landing page now, persona-branched by `TimeLanding`
 * (Employee -> My Time, Client-Manager -> Overview, neither -> the existing denied state).
 * Previously an unconditional redirect to `/time/logs`; that shell is retired (superseded by
 * per-destination routes — see the orchestration doc's IA-gap section).
 */
export const Route = createFileRoute('/time/')({});
